import { render } from "./BannerPWA.vue?vue&type=template&id=62c644a8"
import script from "./BannerPWA.vue?vue&type=script&lang=js"
export * from "./BannerPWA.vue?vue&type=script&lang=js"

import exportComponent from "/Users/stevark/Web/samwash/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__